<div>
    <div class="header">
        @if((versionStatus && forType == 'variant') || (!versionStatus && variant>0 && version == 0)){
            <p class="save-prompt">{{savePromptHeaderTitle}} Variant</p>
        }@else if((versionStatus && forType == 'version') || (!versionStatus && version>0)){
            <p class="save-prompt">{{savePromptHeaderTitle}} Version</p>
        }
        @else{
            <p class="save-prompt">{{savePromptHeaderTitle}}</p>
        }      
    </div>
    <div class="body">
        <div class="complete-txt">{{savePromptTitle}}</div>
        <div class="content-body">
            <form>
                <div class="form-field">
                    <label>Title <span class="required"></span> <img src="/assets/icons/Icon_badge.svg" alt="" title="Use a clear and structured naming convention for easy identification." /> </label>
                    <input class="value" type="text"  placeholder="Value" [formControl]="promptTitle"
                        [ngClass]="{'field-border': isSaveClicked && !promptTitle.value,
    'disabled-dropdown': ((versionStatus && forType == 'version') || (!versionStatus && version>0))}" required
                        (change)="onTitleChange($event)"  />
                    <span class="field-required" *ngIf="isSaveClicked && !promptTitle.value"> <img
                            src="/assets/icons/Red.svg" class="red-icon" alt=""/> Title is required </span>
                </div>
                <div class="form-field">
                    <!-- && latest_version ==0)) -->
                    <label>Category <span class="required"></span></label>
                    <app-select-dropdown class="full-size-width"
                        [ngClass]="{'error-field': isSaveClicked && !category?.name ,
    'disabled-dropdown': ((versionStatus && forType == 'variant') || (!versionStatus && variant>0 && version == 0))}" [options]="categories"
                        (selectionChange)="selectCategory($event)" [selectedOption]="category?.name"
                        placeHolder="Please choose an option"></app-select-dropdown>
                    <span class="field-required" *ngIf="isSaveClicked && !category?.name"> <img
                            src="/assets/icons/Red.svg" class="red-icon" alt=" " /> Category is required </span>
                </div>
                <div class="form-field" *ngIf="category && category.name && (subCategory || category?.value?.subcategories?.length > 0)">
                    <label>SubCategory <span class="required"></span></label>
                    <app-select-dropdown class="full-size-width" [ngClass]="{'error-field': isSaveClicked && !subCategory?.name,
    'disabled-dropdown': ((versionStatus && forType == 'variant') || (!versionStatus && variant>0 && version == 0))}" [options]="subcategories"
                        (selectionChange)="selectSubCategory($event)" [selectedOption]="subCategory?.name"
                        placeHolder="Please choose an option"></app-select-dropdown>
                        <span class="field-required" *ngIf="isSaveClicked && !subCategory?.name"> <img
                            src="/assets/icons/Red.svg" class="red-icon" alt=""/> SubCategory is required </span>
                </div>

               
                    @if(((versionStatus && forType == 'version') || (!versionStatus && version>0))){
                        <div class="form-field reason-height" *ngIf="versionStatus || version>0">
                            <label>Reason for creating version<span class="required"></span></label>
                            <textarea class="value" cols="7"
                                placeHolder="Enter Reason"
                                [formControl]="version_reason" ></textarea>
        
                                <span class="field-required" *ngIf="isSaveClicked && !version_reason.value"> <img
                                    src="/assets/icons/Red.svg" class="red-icon" alt="" /> Version reason is required </span>
        
                        </div>
                    }
                    

                @else if(forType == 'variant' || variant>0){
                    <div class="form-field reason-height" >
                        <label>Reason for creating variant<span class="required"></span></label>
                        <textarea class="value" cols="7"
                            placeHolder="Enter Reason"
                            [formControl]="variant_reason" ></textarea>
                            <span class="field-required" *ngIf="isSaveClicked && !variant_reason.value"> <img
                                src="/assets/icons/Red.svg" class="red-icon" alt="" /> Variant reason is required </span>
                    </div>
            }

                <div class="form-field mn-height">
                    <label>Description</label>
                    <textarea class="value" cols="10"
                        placeHolder="Enter Description"
                        [formControl]="description" (change)="onDescriptionChange($event)"></textarea>
                </div>
                <div class="form-field">
                    <label>Estimated time for this step/sequence of steps</label>
                    <div class="time-field">
                        <div class="time-input-container">
                            <button class="time-btn plus" (click)="increaseHour()">+</button>
                            <input 
                                name="time"
                                class="value" 
                                type="text"  
                                placeholder="00.00"
                                [(ngModel)]="time"
                                (blur)="validateAndFormatTime()"
                                maxlength="5"
                                pattern="^([01]\d|2[0-3]):([0-5]\d)$" />
                            <button class="time-btn minus" (click)="decreaseHour()">−</button>
                        </div>
                        <span>hour(s)</span>
                    </div>
                </div>


               
            </form>
        </div>
    </div>
    <div>
        <div class="btn-div">
            <button class="plain-btn" (click)="onClose()">
                <img class="cancle" src="/assets/icons/Close.svg" alt=""/>Cancel</button>
            
            <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Save'"
                [iconSrc]="'/assets/icons/save_button.svg'" (onClick)="onSave($event)"></app-button>

        </div>
    </div>
</div>